import { render, staticRenderFns } from "./HowToUse.vue?vue&type=template&id=cda61dd4"
import script from "./HowToUse.vue?vue&type=script&lang=js"
export * from "./HowToUse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports